import logoHead from '../LoginLayout/AffiliateLanding/logo-head.png';
import { randomId } from '../../../../common/helpers/utils';
import { Heading, Link } from '@mm/components';
import React from 'react';
import { Routes } from '../../../../routes/top-level-routes';
import css from './GenericFooter.module.css';
import moment from 'moment';

const getFooterColumns = () => [
  [
    'Company',
    [
      ['Home', 'https://mobilemonkey.com/'],
      ['About Us', 'https://mobilemonkey.com/our-team/'],
      ['Terms of Use', Routes.masterServiceAgreement.getLink()],
      ['Privacy Policy', Routes.privacyPolicy.getLink()],
      ['Blog', 'https://mobilemonkey.com/blog'],
      [
        'Affiliate Program',
        'https://mobilemonkey.com/affiliate-reseller-program',
      ],
      ['Help Docs', 'https://mobilemonkey.com/help'],
      [
        'Talk to Us',
        'http://m.me/1754274684887439?ref=fa6f47ac602f9b1965b2668638d86174585c0815641a52ed3d904d',
      ],
      ['Jobs', 'https://mobilemonkey.com/jobs'],
      ['Larry Kim', 'https://mobilemonkey.com/larry-kim'],
    ],
  ],
  [
    'Chatbots',
    [
      ['Chatbot Tools', 'https://mobilemonkey.com/chatbots'],
      ['Chatbot Builder', 'https://mobilemonkey.com/chatbots/chatbot-builder'],
      [
        'How to Build a Chatbot',
        'https://mobilemonkey.com/blog/2018/06/how-to-build-a-facebook-messenger-chatbot',
      ],
      [
        'Chat Blaster',
        'https://mobilemonkey.com/chatbots/facebook-messenger-chat-blaster',
      ],
      [
        'Bot Analytics',
        'https://mobilemonkey.com/chatbots/facebook-messenger-chatbot-analytics',
      ],
      [
        'Chatbot Templates',
        'https://mobilemonkey.com/chatbots/facebook-messenger-templates',
      ],
      ['WordPress Chatbot', 'https://mobilemonkey.com/wp-chatbot/'],
      [
        'How to Segment an Audience',
        'https://mobilemonkey.com/blog/how-to-segment-an-audience',
      ],
      [
        'How to Send a Text Message Blast',
        'https://mobilemonkey.com/blog/how-to-send-a-text-message-blast',
      ],
    ],
  ],
  [
    'Chart Marketing Tools',
    [
      [
        'Facebook Messenger Marketing',
        'https://mobilemonkey.com/chatbots/facebook-messenger-marketing',
      ],
      [
        'Messenger Ads',
        'https://mobilemonkey.com/chatbots/facebook-messenger-ads',
      ],
      [
        'Facebook Post Autoresponder',
        'https://mobilemonkey.com/chatbots/facebook-post-autoresponder',
      ],
      ['Website Chatbot', 'https://mobilemonkey.com/chatbots/website-chatbot'],
      [
        'Live Chat Takeover',
        'https://mobilemonkey.com/chatbots/live-operator-chat-takeover/',
      ],
      [
        'Free Facebook Lead Generator',
        'https://app.mobilemonkey.com/freeleadgenerator',
      ],
      [
        'Messaging Automation',
        'https://mobilemonkey.com/chatbots/facebook-messenger-automation',
      ],
      [
        'Integrations',
        'https://mobilemonkey.com/chatbots/messenger-contact-integrations',
      ],
      [
        'Mobile App',
        'https://mobilemonkey.com/chatbots/chat-marketing-mobile-app',
      ],
      [
        'Contact Growth Tools',
        'https://mobilemonkey.com/chatbots/get-facebook-messenger-contacts',
      ],
    ],
  ],

  [
    'Chatbot Services & Learning',
    [
      [
        'Premier Chatbot Consulting',
        'https://mobilemonkey.com/premier-consulting',
      ],
      ['Find a Chatbot Agency', 'https://mobilemonkey.com/directory'],
      ['Case Studies', 'https://mobilemonkey.com/case-studies/'],
      ['Chatbot University', 'https://mobilemonkey.com/chatbot-tutorial'],
      ['Marketing Summits', 'https://mobilemonkey.com/summits'],
      ['Join the Community', 'https://www.facebook.com/groups/MobileMonkey/'],
      [
        'Premier Chatbot Consulting',
        'https://mobilemonkey.com/premier-consulting',
      ],
      ['Find a Chatbot Agency', 'https://mobilemonkey.com/directory'],
      ['Case Studies', 'https://mobilemonkey.com/case-studies/'],
      ['Chatbot University', 'https://mobilemonkey.com/chatbot-tutorial'],
      ['Marketing Summits', 'https://mobilemonkey.com/summits'],
      ['Join the Community', 'https://www.facebook.com/groups/MobileMonkey/'],
    ],
  ],
];

export const GenericFooter = ({ showNav }: { showNav?: boolean }) => (
  <div className={css.container}>
    <div className={css.footer}>
      <span className={css.adress}>
        Email: contact@mobilemonkey.com | Address: 359 Newbury Street, 5th Floor
        Boston, MA, 02115
      </span>
      <span className={css.copy}>
        © {moment().get('year')} MobileMonkey Inc. All Rights Reserved.
      </span>

      <div className={css.logo}>
        <img src={logoHead} alt="Mobile Monkey" />
      </div>

      {showNav && (
        <nav className={css.nav}>
          {getFooterColumns().map(([section, entries]) => (
            <div className={css.column} key={randomId()}>
              <Heading size={3}>{section}</Heading>

              {Array.isArray(entries) &&
                entries.map(([name, href]) => (
                  <Link
                    className={css.link}
                    href={href}
                    isBlank
                    key={randomId()}
                  >
                    {name}
                  </Link>
                ))}
            </div>
          ))}
        </nav>
      )}
    </div>
  </div>
);
